export default function VideoControls({ isMuted, isCameraOff, onToggleMute, onToggleCamera, disabled }) {
  return (
    <div className="flex items-center gap-2 justify-center">
      <ControlButton
        onClick={onToggleMute}
        disabled={disabled}
        active={isMuted}
        label={isMuted ? 'Unmute' : 'Mute'}
        icon={isMuted ? MicOffIcon : MicIcon}
        danger={isMuted}
      />
      <ControlButton
        onClick={onToggleCamera}
        disabled={disabled}
        active={isCameraOff}
        label={isCameraOff ? 'Camera On' : 'Camera Off'}
        icon={isCameraOff ? CameraOffIcon : CameraIcon}
        danger={isCameraOff}
      />
    </div>
  )
}

function ControlButton({ onClick, disabled, active, label, icon: Icon, danger }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={label}
      className={`
        flex items-center justify-center w-10 h-10 rounded-lg transition-all duration-200
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-400
        disabled:opacity-30 disabled:cursor-not-allowed
        ${danger && active
          ? 'bg-crimson-500/20 border border-crimson-500/40 text-crimson-400 hover:bg-crimson-500/30'
          : 'bg-obsidian-700 border border-obsidian-500 text-ivory-300 hover:bg-obsidian-600 hover:text-ivory-50'
        }
      `}
    >
      <Icon className="w-4 h-4" />
    </button>
  )
}

function MicIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2a3 3 0 0 1 3 3v7a3 3 0 0 1-6 0V5a3 3 0 0 1 3-3z"/>
      <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
      <line x1="12" y1="19" x2="12" y2="22"/>
    </svg>
  )
}

function MicOffIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="1" y1="1" x2="23" y2="23"/>
      <path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"/>
      <path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"/>
      <line x1="12" y1="19" x2="12" y2="22"/>
    </svg>
  )
}

function CameraIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M23 7l-7 5 7 5V7z"/>
      <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
    </svg>
  )
}

function CameraOffIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  )
}
